import size, { SIZE } from './size';
import position, { POSITION } from './position';

export var DEFAULT_VALUE = {
    size: SIZE.zero,
    position: POSITION.left
};

/**
 * Парсер модификатора паддинга
 * @param  {Object} padding_modifier
 * @return {Object}
 */
export default (function (data) {
    if (!data || !data.padding_modifier) {
        return DEFAULT_VALUE;
    }

    var paddingModifier = data.padding_modifier;

    return {
        size: size(paddingModifier.size),
        position: position(paddingModifier.position, POSITION.left)
    };
});